export const NOTIFICATION_TYPE = {
  LEAVE_APPROVAL: 1,
  LEAVE_SUCCESS: 2
}
